//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../Features/Features.SelectFeature.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
let d=[[[1,"CabLength",0,"Expression",0],[1,"CylinderDiameter",0,"Expression",0],[1,"CylinderHeight",0,"Expression",0],[1,"DirectVision",0,"Features.SelectFeature",0],[0,"DriverSide",1,0],[0,"ExistingReferencePoint",1,"Point",0],[1,"LaneWidth",0,"Expression",0],[0,"Loading",1,0],[0,"NumberOfGapPerLane",1,0],[0,"Position",1,0],[0,"ReferencePointMethod",1,0],[0,"Standard",1,0],[0,"UseLoadingSpecifiedByStandard",1,0],[1,"VDVEnvironmentBodySelect",0,"ScCollector",0],[1,"WallHeight",0,"Expression",0],[1,"WallRadius",0,"Expression",0]],[[["nUserRemarks"],"GetUserRemarks",{R_:{userRemarks:""}},0,0],[["userRemarks"],"SetUserRemarks",{},1,0]],[]];
SPLM.Features.VDVEnvironmentBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VDVEnvironmentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VDVEnvironmentBuilder.EnvironmentPositions = Object.freeze({
    "FrontDriver" : "FrontDriver", "FrontCenter" : "FrontCenter", "FrontPassenger" : "FrontPassenger", "RearDriver" : "RearDriver", "RearCenter" : "RearCenter", "RearPassenger" : "RearPassenger", "SideCentreDriver" : "SideCentreDriver", "SideCentrePassenger" : "SideCentrePassenger", "Basedata" : "Basedata", "BasedataAndOcularPoint" : "BasedataAndOcularPoint", "OcularPoint" : "OcularPoint", "BasedataAndFrontCenter" : "BasedataAndFrontCenter"});

SPLM.Features.VDVEnvironmentBuilder.DriverSideForEnvironment = Object.freeze({
    "LeftDriven" : "LeftDriven", "RightDriven" : "RightDriven", "CenterDriven" : "CenterDriven"});

SPLM.Features.VDVEnvironmentBuilder.OcularPointSelectionType = Object.freeze({
    "DirectVision" : "DirectVision", "ExistingPoint" : "ExistingPoint", "NotDefined" : "NotDefined"});

export default SPLM;